import {Component, Input, OnInit} from '@angular/core';
import {SubMenuOption} from '../types/submenu-option';
import {Router} from '@angular/router';

@Component({
  selector: 'sub-menu',
  template: `<ul>
  <li *ngFor="let option of options"
      [class.selected]="option.route === currentRoute"
      routerLink="{{option.route}}"
      routerLinkActive="active">
      {{option.title}}</li></ul>`,
  styles: [
`:host {
  display: block;
  color: #D0D0D0;
  background-color: #1e1e1e;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  height: 2.4em;
  padding: 0.6em;
  vertical-align: middle;
  margin: 0;
  min-height: fit-content;
}`,
`:host * {font-family: Poppins, Arial, "Helvetica Neue", Helvetica, sans-serif;font-weight: bold;}`,
`ul {
  list-style: none;
  margin-block-start: unset;
  margin-block-end: unset;
  padding-inline-start: unset;
}`,
`li {
  display: inline-block;
  padding: 0.4em 0.8em;
  margin: 0.1em 0.7em;
  border-radius: 0.2em;
}`,
`li.selected {
  color: #1e1e1e;
  background-color: #F04E98;
}`,
`li:hover {
  color: #1e1e1e;
  background-color: #FFCD00;
}`,
`@media screen and (min-device-width: 800px) {
  li {
    padding: 0.3em 0.6em;
    margin: 0.1em 0.2em;
    border-radius: 0.1em;
  }
)`,
  ],
})

export class SubmenuComponent implements OnInit {
  @Input() options = <SubMenuOption[]>[];
  @Input() currentRoute = '/unknown';

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    /*
    for (let key of Object.keys(this.router)) {
      try {
        console.log(`Router[: ${key}: ` + JSON.stringify(this.router[key]));
      } catch(e) {
        for (let k2 of Object.keys(this.router[key])) {
          try {
            console.log(`Router[: ${key}:${k2}: ` + JSON.stringify(this.router[key][k2]));
          } catch(e2) {
            console.log(`difficulty with sub-key '${k2}: ${e2}`);
          }
        }
        console.log(`difficulty with key '${key}: ${e}`);
      }
    }
    */
  }
}
